module.exports = __webpack_public_path__ + "img/circulo.9c231d45.svg";